var DailyProgressBarComponent = (function () {
    function DailyProgressBarComponent() {
        this.progress = 0;
        this.color = '#E6A43D';
        this.strokeWidth = 8;
        this.roundedCorners = true;
    }
    DailyProgressBarComponent.prototype.calculateDashArray = function () {
        var circumference = 2 * Math.PI * 15;
        var progressOffset = (circumference * this.progress) / 100;
        return progressOffset + " " + circumference;
    };
    DailyProgressBarComponent.prototype.ngAfterViewInit = function () { };
    return DailyProgressBarComponent;
}());
export { DailyProgressBarComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/activity-achievement/components/calender-progress-bar.component.ts.pre-build-optimizer.js